/**
 * Creator chassis tokens.
 *
 * Each colour reads a CSS custom property that CreatorShell sets from the theme
 * the user picked (see palettes.js), with Puzzly's house palette as fallback.
 * Outside a themed shell (Home, the landing mockups, the first two creator
 * screens) the fallbacks apply, so those look exactly like the approved design.
 */
import { HOUSE } from "./palettes";

const v = (key) => `var(--cr-${key}, ${HOUSE[key]})`;
const rgb = (key, alpha) => `rgba(var(--cr-${key}, ${HOUSE[key]}), ${alpha})`;

export const C = {
  ink: v("ink"),
  body: v("body"),
  soft: v("soft"),
  muted: v("muted"),
  faint: v("faint"),
  label: v("label"),
  line: v("line"),
  dash: v("dash"),
  disabled: v("disabled"),
  disabledBg: v("disabled-bg"),
  accent: v("accent"),
  accentDeep: v("accent-deep"),
  accentSoft: v("accent-soft"),
  onAccent: v("on-accent"),
  ok: v("ok"),
  okDeep: v("ok-deep"),
  surface: v("surface"),
  surfaceAlt: v("surface-alt"),
  badge: v("badge"),
  blob1: v("blob1"),
  blob2: v("blob2"),
  // Fixed white: text and icons drawn on fixed dark or brand-pink backgrounds.
  white: "#FFFFFF",
  // Progress notches
  track: v("track"),
  needed: v("needed"),
  suggested: v("suggested"),
  optional: v("optional"),
};

/** Theme-aware rgba() helpers: shadow tint, accent glow, glass, footer fade. */
export const TINT = {
  shadow: (a) => rgb("shadow-rgb", a),
  accent: (a) => rgb("accent-rgb", a),
  glass: (a) => rgb("glass-rgb", a),
  fade: (a) => rgb("fade-rgb", a),
};

export const FONT = "'Plus Jakarta Sans', system-ui, -apple-system, sans-serif";
export const SERIF = "'Cormorant Garamond', Georgia, serif";

export const SHADOW = {
  card: `0 1px 2px ${TINT.shadow(0.05)}, 0 14px 30px -20px ${TINT.shadow(0.4)}`,
  raised: `0 1px 2px ${TINT.shadow(0.06)}, 0 8px 18px -8px ${TINT.shadow(0.22)}`,
  focus: `0 0 0 5px ${TINT.accent(0.1)}, 0 22px 44px -20px ${TINT.accent(0.4)}`,
  primary: `0 16px 30px -12px ${TINT.accent(0.65)}, inset 0 1px 0 rgba(255,255,255,0.22)`,
};

export const GRADIENT = {
  primary: `linear-gradient(135deg, ${v("accent-2")} 0%, ${v("accent-deep")} 100%)`,
  page: v("page"),
};

export const RADIUS = { field: 24, card: 20, pill: 999, button: 19 };
